import type { ShowcaseRoomBCondition, ShowcaseSource } from './showcasePresentation';

export type { ShowcaseRoomBCondition, ShowcaseSource };

export type ShowcaseTrustSurface = {
  qualitativeNow: boolean;
  lastCompleted: boolean;
  recurring: boolean;
  verification: boolean;
};

export const SHOWCASE_TRUST_ROOM_B_RAE: ShowcaseTrustSurface = {
  qualitativeNow: true,
  lastCompleted: true,
  recurring: true,
  verification: true,
};

export const SHOWCASE_TRUST_ROOM_B_PROXIMITY: ShowcaseTrustSurface = {
  qualitativeNow: true,
  lastCompleted: true,
  recurring: true,
  verification: true,
};

export const SHOWCASE_TRUST_BOOTH_RAE: ShowcaseTrustSurface = {
  qualitativeNow: true,
  lastCompleted: true,
  recurring: true,
  verification: true,
};

/**
 * Centralized visitor-surface trust. verification=true means canonical
 * lifecycle status may be shown, not that a verified outcome exists.
 */
export function showcaseTrustFor(
  source: ShowcaseSource,
  roomBCondition: ShowcaseRoomBCondition = 'rae',
): ShowcaseTrustSurface {
  if (source === 'booth') return SHOWCASE_TRUST_BOOTH_RAE;
  if (roomBCondition === 'proximity') return SHOWCASE_TRUST_ROOM_B_PROXIMITY;
  return SHOWCASE_TRUST_ROOM_B_RAE;
}

export function showcaseAllowsLastCompleted(trust: ShowcaseTrustSurface): boolean {
  return trust.lastCompleted;
}

export function showcaseAllowsRecurringNumbers(trust: ShowcaseTrustSurface): boolean {
  return trust.recurring;
}

export function showcaseAllowsQualitativeNow(trust: ShowcaseTrustSurface): boolean {
  return trust.qualitativeNow;
}

export function showcaseAllowsVerificationStatus(trust: ShowcaseTrustSurface): boolean {
  return trust.verification;
}
